import { connect } from 'react-redux';
import ProfileTab from './ProfileTab';
import mapDispatchToProps from './mapDispatchToProps';
import mapStateToProps from './mapStateToProps';
import { withTheme } from 'styled-components';

const themedProfileTab = withTheme(ProfileTab);

export default connect(mapStateToProps, mapDispatchToProps)(themedProfileTab);
